import type { AnnotationBundleIssue } from "../domain/annotationBundle";

export function annotationBundleIssueText(issue: AnnotationBundleIssue): string {
  const sample = issue.samplePath ? ` (${issue.samplePath})` : "";
  switch (issue.code) {
    case "empty":
      return "가져올 PNG/YAML 파일을 선택해 주세요.";
    case "too_many_files":
      return `번들에는 파일을 최대 500개까지 포함할 수 있습니다. 현재 ${issue.count}개입니다.`;
    case "total_size_exceeded":
      return "PNG/YAML 번들의 합계는 128 MiB까지 지원합니다. 파일을 나누어 가져와 주세요.";
    case "invalid_path":
      return `카메라 폴더 바로 아래에 PNG/YAML 파일을 넣어 주세요.${sample}`;
    case "invalid_size":
      return `빈 파일이나 크기 제한을 넘는 파일이 있습니다. PNG는 32 MiB, YAML은 1 MiB까지 지원합니다.${sample}`;
    case "unknown_camera":
      return `Dataset에 없는 카메라의 파일이 ${issue.count}개 있습니다.${sample}`;
    case "duplicate_path":
      return `같은 경로의 파일이 중복되어 있습니다.${sample}`;
    case "incomplete_pair":
      return `이름이 같은 PNG/YAML 짝이 ${issue.count}개 누락되어 있습니다.${sample}`;
    case "mask_source_missing":
      return `원본 영상이 없는 mask가 ${issue.count}개 있습니다.${sample}`;
  }
}
